// @generated by protoc-gen-es v2.12.1 with parameter "target=ts"
// @generated from file api/gateway/v1/installation_state.proto (package gateway.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file api/gateway/v1/installation_state.proto.
 */
export const file_api_gateway_v1_installation_state: GenFile = /*@__PURE__*/
  fileDesc("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", [file_google_protobuf_timestamp]);

/**
 * InstallationState represents an operational state that can be assigned to an installation.
 *
 * @generated from message gateway.v1.InstallationState
 */
export type InstallationState = Message<"gateway.v1.InstallationState"> & {
  /**
   * uuid is the unique identifier for the installation state.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * custom_name is the display name of the state when state is CUSTOM. For predefined states, this can be set to the default name or left empty.
   *
   * @generated from field: string custom_name = 2;
   */
  customName: string;

  /**
   * color is the hex color code associated with this state for visual identification (e.g., "#FF0000").
   *
   * @generated from field: string color = 3;
   */
  color: string;

  /**
   * default_state links this state to a predefined system state. Set to UNSPECIFIED for custom states.
   *
   * @generated from field: gateway.v1.InstallationStateType state = 4;
   */
  state: InstallationStateType;

  /**
   * created_at timestamp when the state was created.
   *
   * @generated from field: google.protobuf.Timestamp created_at = 5;
   */
  createdAt?: Timestamp | undefined;

  /**
   * updated_at timestamp when the state was last updated.
   *
   * @generated from field: google.protobuf.Timestamp updated_at = 6;
   */
  updatedAt?: Timestamp | undefined;
};

/**
 * Describes the message gateway.v1.InstallationState.
 * Use `create(InstallationStateSchema)` to create a new message.
 */
export const InstallationStateSchema: GenMessage<InstallationState> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_state, 0);

/**
 * CreateInstallationStateRequest is the request message for creating a new installation state.
 *
 * @generated from message gateway.v1.CreateInstallationStateRequest
 */
export type CreateInstallationStateRequest = Message<"gateway.v1.CreateInstallationStateRequest"> & {
  /**
   * custom_name is the display name of the new state.
   *
   * @generated from field: string custom_name = 1;
   */
  customName: string;

  /**
   * color is the hex color code for the new state.
   *
   * @generated from field: string color = 2;
   */
  color: string;
};

/**
 * Describes the message gateway.v1.CreateInstallationStateRequest.
 * Use `create(CreateInstallationStateRequestSchema)` to create a new message.
 */
export const CreateInstallationStateRequestSchema: GenMessage<CreateInstallationStateRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_state, 1);

/**
 * CreateInstallationStateResponse is the response message for the CreateInstallationState RPC.
 *
 * @generated from message gateway.v1.CreateInstallationStateResponse
 */
export type CreateInstallationStateResponse = Message<"gateway.v1.CreateInstallationStateResponse"> & {
  /**
   * installation_state is the newly created installation state.
   *
   * @generated from field: gateway.v1.InstallationState installation_state = 1;
   */
  installationState?: InstallationState | undefined;
};

/**
 * Describes the message gateway.v1.CreateInstallationStateResponse.
 * Use `create(CreateInstallationStateResponseSchema)` to create a new message.
 */
export const CreateInstallationStateResponseSchema: GenMessage<CreateInstallationStateResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_state, 2);

/**
 * GetInstallationStateByUuidRequest is the request message for retrieving an installation state by UUID.
 *
 * @generated from message gateway.v1.GetInstallationStateByUuidRequest
 */
export type GetInstallationStateByUuidRequest = Message<"gateway.v1.GetInstallationStateByUuidRequest"> & {
  /**
   * uuid is the unique identifier of the installation state to retrieve.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.GetInstallationStateByUuidRequest.
 * Use `create(GetInstallationStateByUuidRequestSchema)` to create a new message.
 */
export const GetInstallationStateByUuidRequestSchema: GenMessage<GetInstallationStateByUuidRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_state, 3);

/**
 * GetInstallationStateByUuidResponse is the response message for the GetInstallationStateByUuid RPC.
 *
 * @generated from message gateway.v1.GetInstallationStateByUuidResponse
 */
export type GetInstallationStateByUuidResponse = Message<"gateway.v1.GetInstallationStateByUuidResponse"> & {
  /**
   * installation_state is the installation state retrieved based on the provided UUID.
   *
   * @generated from field: gateway.v1.InstallationState installation_state = 1;
   */
  installationState?: InstallationState | undefined;
};

/**
 * Describes the message gateway.v1.GetInstallationStateByUuidResponse.
 * Use `create(GetInstallationStateByUuidResponseSchema)` to create a new message.
 */
export const GetInstallationStateByUuidResponseSchema: GenMessage<GetInstallationStateByUuidResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_state, 4);

/**
 * GetInstallationStateListRequest is the request message for retrieving all installation states.
 *
 * @generated from message gateway.v1.GetInstallationStateListRequest
 */
export type GetInstallationStateListRequest = Message<"gateway.v1.GetInstallationStateListRequest"> & {
};

/**
 * Describes the message gateway.v1.GetInstallationStateListRequest.
 * Use `create(GetInstallationStateListRequestSchema)` to create a new message.
 */
export const GetInstallationStateListRequestSchema: GenMessage<GetInstallationStateListRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_state, 5);

/**
 * GetInstallationStateListResponse is the response message for the GetInstallationStateList RPC.
 *
 * @generated from message gateway.v1.GetInstallationStateListResponse
 */
export type GetInstallationStateListResponse = Message<"gateway.v1.GetInstallationStateListResponse"> & {
  /**
   * installation_states is the list of all installation states.
   *
   * @generated from field: repeated gateway.v1.InstallationState installation_states = 1;
   */
  installationStates: InstallationState[];
};

/**
 * Describes the message gateway.v1.GetInstallationStateListResponse.
 * Use `create(GetInstallationStateListResponseSchema)` to create a new message.
 */
export const GetInstallationStateListResponseSchema: GenMessage<GetInstallationStateListResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_state, 6);

/**
 * UpdateInstallationStateRequest is the request message for updating an installation state.
 *
 * @generated from message gateway.v1.UpdateInstallationStateRequest
 */
export type UpdateInstallationStateRequest = Message<"gateway.v1.UpdateInstallationStateRequest"> & {
  /**
   * uuid is the unique identifier of the installation state to update.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;

  /**
   * custom_name is the updated display name.
   *
   * @generated from field: string custom_name = 2;
   */
  customName: string;

  /**
   * color is the updated hex color code.
   *
   * @generated from field: string color = 3;
   */
  color: string;
};

/**
 * Describes the message gateway.v1.UpdateInstallationStateRequest.
 * Use `create(UpdateInstallationStateRequestSchema)` to create a new message.
 */
export const UpdateInstallationStateRequestSchema: GenMessage<UpdateInstallationStateRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_state, 7);

/**
 * UpdateInstallationStateResponse is the response message for the UpdateInstallationState RPC.
 *
 * @generated from message gateway.v1.UpdateInstallationStateResponse
 */
export type UpdateInstallationStateResponse = Message<"gateway.v1.UpdateInstallationStateResponse"> & {
  /**
   * installation_state is the updated installation state.
   *
   * @generated from field: gateway.v1.InstallationState installation_state = 1;
   */
  installationState?: InstallationState | undefined;
};

/**
 * Describes the message gateway.v1.UpdateInstallationStateResponse.
 * Use `create(UpdateInstallationStateResponseSchema)` to create a new message.
 */
export const UpdateInstallationStateResponseSchema: GenMessage<UpdateInstallationStateResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_state, 8);

/**
 * DeleteInstallationStateRequest is the request message for deleting an installation state.
 *
 * @generated from message gateway.v1.DeleteInstallationStateRequest
 */
export type DeleteInstallationStateRequest = Message<"gateway.v1.DeleteInstallationStateRequest"> & {
  /**
   * uuid is the unique identifier of the installation state to delete.
   *
   * @generated from field: string uuid = 1;
   */
  uuid: string;
};

/**
 * Describes the message gateway.v1.DeleteInstallationStateRequest.
 * Use `create(DeleteInstallationStateRequestSchema)` to create a new message.
 */
export const DeleteInstallationStateRequestSchema: GenMessage<DeleteInstallationStateRequest> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_state, 9);

/**
 * DeleteInstallationStateResponse is the response message for the DeleteInstallationState RPC.
 *
 * @generated from message gateway.v1.DeleteInstallationStateResponse
 */
export type DeleteInstallationStateResponse = Message<"gateway.v1.DeleteInstallationStateResponse"> & {
};

/**
 * Describes the message gateway.v1.DeleteInstallationStateResponse.
 * Use `create(DeleteInstallationStateResponseSchema)` to create a new message.
 */
export const DeleteInstallationStateResponseSchema: GenMessage<DeleteInstallationStateResponse> = /*@__PURE__*/
  messageDesc(file_api_gateway_v1_installation_state, 10);

/**
 * InstallationState defines the predefined installation states provided by the system.
 *
 * @generated from enum gateway.v1.InstallationStateType
 */
export enum InstallationStateType {
  /**
   * Unspecified state, used as a default value.
   *
   * @generated from enum value: INSTALLATION_STATE_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * OK state, indicating the installation is operating normally.
   *
   * @generated from enum value: INSTALLATION_STATE_TYPE_OK = 1;
   */
  OK = 1,

  /**
   * Urgent state, indicating the installation requires immediate attention.
   *
   * @generated from enum value: INSTALLATION_STATE_TYPE_URGENT = 2;
   */
  URGENT = 2,

  /**
   * In maintenance state, indicating the installation is undergoing maintenance.
   *
   * @generated from enum value: INSTALLATION_STATE_TYPE_IN_MAINTENANCE = 3;
   */
  IN_MAINTENANCE = 3,

  /**
   * Public water invasion state, indicating the installation is affected by public water ingress.
   *
   * @generated from enum value: INSTALLATION_STATE_TYPE_PUBLIC_WATER_INVASION = 4;
   */
  PUBLIC_WATER_INVASION = 4,

  /**
   * Custom state, indicating a user-defined state.
   *
   * @generated from enum value: INSTALLATION_STATE_TYPE_CUSTOM = 5;
   */
  CUSTOM = 5,

  /**
   * Error state, a error state for the system.
   *
   * @generated from enum value: INSTALLATION_STATE_TYPE_ERROR = 6;
   */
  ERROR = 6,
}

/**
 * Describes the enum gateway.v1.InstallationStateType.
 */
export const InstallationStateTypeSchema: GenEnum<InstallationStateType> = /*@__PURE__*/
  enumDesc(file_api_gateway_v1_installation_state, 0);

/**
 * InstallationStateService defines the gRPC service for managing installation states.
 *
 * -------------------------------------------------------------------------
 * InstallationState CRUD operations
 * -------------------------------------------------------------------------
 *
 * @generated from service gateway.v1.InstallationStateService
 */
export const InstallationStateService: GenService<{
  /**
   * CreateInstallationState creates a new custom installation state.
   *
   * @generated from rpc gateway.v1.InstallationStateService.CreateInstallationState
   */
  createInstallationState: {
    methodKind: "unary";
    input: typeof CreateInstallationStateRequestSchema;
    output: typeof CreateInstallationStateResponseSchema;
  },
  /**
   * GetInstallationStateByUuid retrieves an installation state by its unique identifier.
   *
   * @generated from rpc gateway.v1.InstallationStateService.GetInstallationStateByUuid
   */
  getInstallationStateByUuid: {
    methodKind: "unary";
    input: typeof GetInstallationStateByUuidRequestSchema;
    output: typeof GetInstallationStateByUuidResponseSchema;
  },
  /**
   * GetInstallationStateList retrieves all installation states.
   *
   * @generated from rpc gateway.v1.InstallationStateService.GetInstallationStateList
   */
  getInstallationStateList: {
    methodKind: "unary";
    input: typeof GetInstallationStateListRequestSchema;
    output: typeof GetInstallationStateListResponseSchema;
  },
  /**
   * UpdateInstallationState updates an existing installation state.
   *
   * @generated from rpc gateway.v1.InstallationStateService.UpdateInstallationState
   */
  updateInstallationState: {
    methodKind: "unary";
    input: typeof UpdateInstallationStateRequestSchema;
    output: typeof UpdateInstallationStateResponseSchema;
  },
  /**
   * DeleteInstallationState removes a custom installation state.
   *
   * @generated from rpc gateway.v1.InstallationStateService.DeleteInstallationState
   */
  deleteInstallationState: {
    methodKind: "unary";
    input: typeof DeleteInstallationStateRequestSchema;
    output: typeof DeleteInstallationStateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_api_gateway_v1_installation_state, 0);

